<table class="table table-hover table-stripped"style="width:100%">
  <thead>
    <tr>

    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let note of conf.notes">
      <tr *ngIf="conf.show.major">
        <td><a routerLink="/chordsteps/{{note}}">{{note}}</a></td>
        <td *ngFor="let step of conf.chordsteps">
          <app-chord-render [chord]="getStep(note, step)" [instrument]="conf.instrument" [graph]="true"></app-chord-render>
          <app-chord-render [chord]="note" [level]="step" [instrument]="conf.instrument" [graph]="true"></app-chord-render>
        </td>
      </tr>
      <tr *ngIf="conf.show.minor">
        <td><a routerLink="/chordsteps/{{note}}m">{{note}}m</a></td>
        <td *ngFor="let step of conf.chordsteps">
          <app-chord-render [chord]="getStep(note + 'm', step)" [instrument]="conf.instrument" [graph]="true"></app-chord-render>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

